import moment from "moment";

/**
 * Formats a date into a specified string format.
 * @param {any} date - The date value to format (can be a string, Date object, or moment-compatible value).
 * @param {string} format - The moment.js format string (e.g., "YYYY-MM-DD", "MM/DD/YYYY").
 * @param {string} [fallback=""] - The fallback value to return if the date is invalid or falsy.
 * @returns {string} The formatted date string, or the fallback value if the date is invalid.
 * @example
 * formatDate("2024-01-15", "MM/DD/YYYY") // Returns "01/15/2024"
 * formatDate(null, "YYYY-MM-DD", "N/A") // Returns "N/A"
 */
export const formatDate = (date: any, format: string, fallback: string = "") =>
  date && moment(date).isValid() ? moment(date).format(format) : fallback;

/**
 * Checks if two date strings represent the same date.
 * @param {string} [date1] - The first date string to compare.
 * @param {string} [date2] - The second date string to compare.
 * @returns {boolean} True if both dates are valid and represent the same date, false otherwise.
 * @example
 * checkIfDatesAreSame("2024-01-15", "2024-01-15") // Returns true
 * checkIfDatesAreSame("2024-01-15", "2024-01-16") // Returns false
 * checkIfDatesAreSame(undefined, "2024-01-15") // Returns false
 */
export const checkIfDatesAreSame = (date1?: string, date2?: string) => {
  if (!date1 || !date2) {
    return false;
  }
  const result = moment(date1).isSame(moment(date2));
  return result;
};
